import React from "react";
import "./Footer.scss";
import AppStore from "../../images/app-store.svg";
import PlayStore from "../../images/google-play-store.svg";
import MyBykLogo from "../../images/logo-inverted.svg";
import InsW from "../../images/insta-w.svg";
import Xw from "../../images/x-w.svg";
import Yw from "../../images/utube-w.svg";
import LinkedW from "../../images/im-w.svg";
import FbW from "../../images/fb-2.svg";
import { useLocation , useNavigate} from "react-router-dom";

const Footer = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const queryParams = new URLSearchParams(location.search);
  const q = queryParams.get("q");
  const handleLogoClick = () => {
    window.scrollTo({ top: 0, behavior: "instant" });
    if (q) {
      navigate(`/?q=${encodeURIComponent(q)}`);
    } else {
      navigate("/");
    }
  };
  return (
    <section className="footer">
      <div className="container">
        <div className="footer__wrap-m">
          <div className="footer__wrap-m-company">
            <p>Company</p>
            <ul>
              {/* <li>
                <a
                  href="https://mybyk.in/partners/"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="partner-with-us"
                >
                  Partner With Us
                </a>
              </li> */}
              {/* <li>
                <a
                  href="https://mybyk.in/advertise/"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="advertise"
                >
                  Advertise
                </a>
              </li> */}
              <li>
                <a
                  href="https://mybyk.in/assets/MYBYK-Brand-guidlines-Cme3OREn.pdf"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="media-kit"
                >
                  Media Kit
                </a>
              </li>
            </ul>

            <div className="footer__wrap-m-company-get">
              <p>Get The App</p>
              <a
                href="https://apps.apple.com/in/app/mybyk-pedal-ebike-rental/id1302751321"
                target="_blank"
                rel="noreferrer"
                aria-label="download-on-app-store"
              >
                <img src={AppStore} alt="" />
              </a>
              <br />
              <a
                href="https://play.google.com/store/apps/details?id=in.greenpedia.mybyk&hl=en_IN"
                target="_blank"
                rel="noreferrer"
                aria-label="download-on-play-store"
              >
                <img src={PlayStore} alt="" />
              </a>
            </div>
          </div>
          <div className="footer__wrap-m-company footer__wrap-m-legal">
            <p>Legal</p>
            <ul>
              <li>
                <a
                  href="https://mybyk.in/terms/"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="terms"
                >
                  Terms
                </a>
              </li>
              <li>
                <a
                  href="https://mybyk.in/privacy-policy/"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="privacy"
                >
                  Privacy
                </a>
              </li>
            </ul>
            <div className="footer__wrap-m-company-social">
              <p>Find Us On</p>
              <a
                href="https://www.instagram.com/mybyk.in?igsh=MWtwZzY3d2Nwa254Mg=="
                target="_blank"
                rel="noreferrer"
                aria-label="instagram"
              >
                <img src={InsW} alt="" />
              </a>
              <a
                href="https://www.facebook.com/mybyk.in/"
                target="_blank"
                rel="noreferrer"
                aria-label="facebook"
              >
                <img src={FbW} alt="" />
              </a>
              <a
                href="https://www.linkedin.com/company/mybyk"
                target="_blank"
                rel="noreferrer"
                aria-label="linkedin"
              >
                <img src={LinkedW} alt="" />
              </a>
              <a
                href="https://twitter.com/mybyk_in"
                target="_blank"
                rel="noreferrer"
                aria-label="twitter"
              >
                <img src={Xw} alt="" />
              </a>
              <a
                href="https://www.youtube.com/@mybykindia"
                target="_blank"
                rel="noreferrer"
                aria-label="youtube"
              >
                <img src={Yw} alt="" />
              </a>
            </div>
          </div>
        </div>

        <div className="footer__wrap-d">
          <div className="footer__wrap-d-company">
            <p>Company</p>
            <ul>
              {/* <li>
                <a
                  href="https://mybyk.in/partners/"
                  rel="noreferrer"
                  target="_blank"
                >
                  Partner With Us
                </a>
              </li> */}
              {/* <li>
                <a
                  href="https://mybyk.in/advertise/"
                  target="_blank"
                  rel="noreferrer"
                >
                  Advertise
                </a>
              </li> */}
              <li>
                <a
                  href="https://mybyk.in/assets/MYBYK-Brand-guidlines-Cme3OREn.pdf"
                  target="_blank"
                  rel="noreferrer"
                >
                  Media Kit
                </a>
              </li>
            </ul>
          </div>
          <div className="footer__wrap-d-legal footer__wrap-d-company">
            <p>Legal</p>
            <ul>
              <li>
                <a
                  href="https://mybyk.in/terms/"
                  aria-label="terms"
                  target="_blank"
                  rel="noreferrer"
                >
                  Terms
                </a>
              </li>
              <li>
                <a
                  href="https://mybyk.in/privacy-policy/"
                  aria-label="privacy"
                  target="_blank"
                  rel="noreferrer"
                >
                  Privacy
                </a>
              </li>
             
            </ul>
          </div>
          <div className="footer__wrap-d-company-get">
            <p>Get The App</p>
            <a
              href="https://apps.apple.com/in/app/mybyk-pedal-ebike-rental/id1302751321"
              target="_blank"
              rel="noreferrer"
            >
              <img src={AppStore} alt="" aria-label="download-on-app-store" />
            </a>
            <br />
            <a
              href="https://play.google.com/store/apps/details?id=in.greenpedia.mybyk&hl=en_IN"
              target="_blank"
              rel="noreferrer"
            >
              <img src={PlayStore} alt="" aria-label="download-on-play-store" />
            </a>
          </div>
          <div className="footer__wrap-d-company-social">
            <p>Find Us On</p>

            <a
              href="https://www.instagram.com/mybyk.in?igsh=MWtwZzY3d2Nwa254Mg=="
              target="_blank"
              rel="noreferrer"
              aria-label="instagram"
            >
              <img src={InsW} alt="" />
            </a>
            <a
              href="https://www.facebook.com/mybyk.in/"
              target="_blank"
              rel="noreferrer"
              aria-label="facebook"
            >
              <img src={FbW} alt="" />
            </a>
            <a
              href="https://www.linkedin.com/company/mybyk"
              target="_blank"
              rel="noreferrer"
              aria-label="linkedin"
            >
              <img src={LinkedW} alt="" />
            </a>
            <a
              href="https://twitter.com/mybyk_in"
              target="_blank"
              rel="noreferrer"
              aria-label="twitter"
            >
              <img src={Xw} alt="" />
            </a>
            <a
              href="https://www.youtube.com/@mybykindia"
              target="_blank"
              rel="noreferrer"
              aria-label="youtube"
            >
              <img src={Yw} alt="" />
            </a>
          </div>
        </div>

        <hr />

        <div className="footer__company-info">
          <figure>
            <button onClick={handleLogoClick}>
              <img src={MyBykLogo} alt="" aria-label="home" />
            </button>
          </figure>

          <div>
            <p>© {new Date().getFullYear()} MYBYK. All rights reserved.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Footer;
